import React from 'react'
import { inject, observer } from 'mobx-react'
import { compose, lifecycle, withHandlers } from 'recompose'
import { withTranslation } from 'react-i18next'

const enhance = compose(
  withHandlers({
    handleLevelIndexChange: ({ uiStore, shapefile }) => async index => {
      shapefile.selectedLevelIndex = index
      await shapefile.selectedLevel.load()
      if (shapefile.selectedLevel.preview === true) {
        uiStore.setBoundsToItem(shapefile.selectedLevel)
      }
    }
  }),
  lifecycle({
    componentDidMount () {
      // initially select the first shapefile level
      this.props.handleLevelIndexChange(0)
    }
  })
)

const UserShapefileLevelListSelect = ({
  shapefile,
  handleLevelIndexChange, t
}) => shapefile.levels.length > 1 && (
  <label>
    <span>{t('GLOBAL.CHOOSE_DATA_SET')}</span>
    <div className='custom-select'>
      <select
        value={
        shapefile.selectedLevelIndex === null
          ? ''
          : shapefile.selectedLevelIndex
      }
        onChange={
        e => handleLevelIndexChange(e.currentTarget.value)
      }
      >
        {
          shapefile.levels.map((level, i) => (
            <option value={i} key={level.id}>
              {level.name}
            </option>
          ))
        }
      </select>
    </div>
  </label>
)

export default withTranslation()(inject('uiStore')(observer(enhance(UserShapefileLevelListSelect))))
